"use client";

import { BookOpen, Shield, Sparkles, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const values = [{
  icon: Shield,
  title: "Absolute Privacy",
  description: "Experience your aesthetic journey in a completely private, secure, and discreet environment tailored to your comfort."
}, {
  icon: Sparkles,
  title: "Refined Balancing",
  description: "We focus on subtle facial harmony, using precision techniques to enhance your natural features rather than altering them."
}, {
  icon: Users,
  title: "Concierge Care",
  description: "Skip the waiting rooms and traffic. Our mobile service brings professional, high-end aesthetic care directly to your door."
}, {
  icon: BookOpen,
  title: "Preventative Wellness",
  description: "Utilizing advanced fillers and neurotoxins to support skin health and prevent signs of aging before they become prominent."
}];
export default function TheLuxuryOfConvenience() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="18901" id="the-luxury-of-convenience" className="dark bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-20">
        <div ref={headerRef} className="mx-auto max-w-[720px] text-center" style={{
        opacity: headerVisible ? 1 : 0,
        transform: headerVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 720ms cubic-bezier(0.22, 0.61, 0.36, 1), transform 720ms cubic-bezier(0.22, 0.61, 0.36, 1)"
      }}>
          <p className="font-default text-sm font-medium tracking-wide text-primary">
            Our Philosophy
          </p>
          <h2 className="mt-6 font-default text-[clamp(2.125rem,3.8vw,3.25rem)] font-normal leading-[1.08] tracking-tight text-foreground">
            The luxury of{" "}
            <em className="font-default font-light italic">convenience</em>
          </h2>
          <p className="mt-6 font-default text-[clamp(1.125rem,1.4vw,1.3125rem)] leading-[1.65] text-muted-foreground">We redefine aesthetic medicine by blending clinical excellence with tailored concierge service, ensuring your path to radiance is effortless, private, and perfectly balanced.</p>
        </div>

        <div ref={gridRef} className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((value, i) => {
          const Icon = value.icon;
          return <div key={value.title} data-index={i} className="group rounded-lg bg-card p-9 shadow-md transition-shadow duration-[360ms] ease-out hover:shadow-lg" style={{
            opacity: gridVisible ? 1 : 0,
            transform: gridVisible ? "translateY(0) translateZ(0)" : "translateY(16px) translateZ(0)",
            willChange: "opacity, transform",
            transition: `opacity 720ms cubic-bezier(0.22, 0.61, 0.36, 1) ${i * 120}ms, transform 720ms cubic-bezier(0.22, 0.61, 0.36, 1) ${i * 120}ms, box-shadow 360ms ease-out`
          }}>
                <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-accent">
                  <Icon className="h-7 w-7 text-primary" strokeWidth={1.5} aria-hidden="true" />
                </div>
                <h3 className="mt-7 font-default text-[clamp(1.375rem,1.8vw,1.75rem)] font-medium leading-[1.2] tracking-tight text-foreground">
                  {value.title}
                </h3>
                <p className="mt-4 font-default text-base leading-[1.7] text-muted-foreground">
                  {value.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}